import React, { useMemo } from "react";
import { Alert } from "react-bootstrap";
import Dropzone from "react-dropzone";
import { withTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faCircleNotch, faTimes } from "@fortawesome/free-solid-svg-icons";
import DateTimeHelper from "../../../../../../helpers/DateTimeHelper";

class FileUploadTab extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      files: []
    };

    this.baseStyle = {
      flex: 1,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      padding: "20px",
      borderWidth: 2,
      borderRadius: 2,
      borderColor: "#eeeeee",
      borderStyle: "dashed",
      backgroundColor: "#fafafa",
      color: "#bdbdbd",
      outline: "none",
      transition: "border .24s ease-in-out"
    };

    this.activeStyle = {
      borderColor: "#2196f3"
    };

    this.acceptStyle = {
      borderColor: "#00e676"
    };

    this.rejectStyle = {
      borderColor: "#ff1744"
    };

    this.onUpload = this.onUpload.bind(this);
    this.onHide = this.onHide.bind(this);
    this.humanReadableFileSize = this.humanReadableFileSize.bind(this);
  }

  onHide() {
    this.props.onHide();
  }

  async onUpload(files) {
    files = files.map(f => {
      f["status"] = 0;
      return f;
    });
    this.setState({ files });
    const uploadedFiles = await this.props.onUpload(files);
    this.setState({ uploadedFiles });
  }

  humanReadableFileSize(size) {
    const labels = ["B", "KB", "MB", "GB"];
    let ct = 0;
    while (size > 1024 && ct < labels.length) {
      size /= 1024;
      ct++;
    }
    return `${Math.round(size * 100) / 100} ${labels[ct]}`;
  }

  render() {
    const { t } = this.props;
    const now = Date.now();
    const submissionEndDate = this.props.studentExamination.examinationRestrictions.submissionEndDate;
    const submissionEndDateTimestamp = submissionEndDate ? new Date(submissionEndDate).getTime() : null;
    const fileState = [
      <FontAwesomeIcon key={1} icon={faCircleNotch} pulse className="color-black mr-2" />,
      <FontAwesomeIcon key={2} icon={faCheck} className="color-green mr-2" />,
      <FontAwesomeIcon key={3} icon={faTimes} className="color-red mr-2" />
    ];
    let restrictionsDiskSpace = (
      <FontAwesomeIcon icon={faCircleNotch} spin className="color-black" />
    );
    let restrictionsFileCount = (
      <FontAwesomeIcon icon={faCircleNotch} spin className="color-black" />
    );
    let restrictionsFileTypes = (
      <FontAwesomeIcon icon={faCircleNotch} spin className="color-black" />
    );
    if (this.props.studentExamination) {
      const totalUploaded = this.props.studentFileProposals.reduce(
        (accu, i) => accu + i.size,
        0
      );
      restrictionsFileCount =
        this.props.studentExamination.examinationRestrictions.maxNumberFiles -
        this.props.studentFileProposals.length;
      restrictionsDiskSpace = this.humanReadableFileSize(
        Math.abs(
          this.props.studentExamination.examinationRestrictions.maxTotalSize -
          totalUploaded
        )
      );
      restrictionsFileTypes =
        this.props.studentExamination.examinationRestrictions.allowedFileTypes
          .length > 0
          ? this.props.studentExamination.examinationRestrictions.allowedFileTypes.join(
            ", "
          )
          : t(
            "ExaminationAccess.UploadManagerDialog.FileUploadTab.NoRestrictions"
          );
    }
    return (
      <div className="mt-2">
        {this.props.dialogApiError}
        <Alert key="2" variant="warning">
          <p>
            {t(
              "ExaminationAccess.UploadManagerDialog.FileUploadTab.AcceptedSubmissions"
            )}
          </p>
          <ol>
            <li>
              <b>
                {t(
                  "ExaminationAccess.UploadManagerDialog.FileUploadTab.AllowedFileTypes"
                )}
                :{" "}
              </b>
              {restrictionsFileTypes}
            </li>
            <li>
              <b>
                {t(
                  "ExaminationAccess.UploadManagerDialog.FileUploadTab.AvailableDiskSpace"
                )}
                :{" "}
              </b>
              {restrictionsDiskSpace}
            </li>
            <li>
              <b>
                {t(
                  "ExaminationAccess.UploadManagerDialog.FileUploadTab.AvailableFileCount"
                )}
                :{" "}
              </b>
              {restrictionsFileCount}
            </li>
            {submissionEndDate ? (
                <li>
                  <b>
                    {t(
                        "ExaminationAccess.UploadManagerDialog.FileUploadTab.SubmissionEndDate"
                    )}
                    :{" "}
                  </b>
                  {DateTimeHelper.formatDate(submissionEndDate)}
                </li>
            ) : ""}
          </ol>
        </Alert>
        {submissionEndDateTimestamp === null || (submissionEndDateTimestamp >= now) ? (
            <Dropzone onDrop={this.onUpload}>
              {({
                  getRootProps,
                  getInputProps,
                  isDragActive,
                  isDragAccept,
                  isDragReject
                }) => {
                const style = useMemo(
                    () => ({
                      ...this.baseStyle,
                      ...(isDragActive ? this.activeStyle : {}),
                      ...(isDragAccept ? this.acceptStyle : {}),
                      ...(isDragReject ? this.rejectStyle : {})
                    }),
                    [isDragActive, isDragReject, isDragAccept]
                );

                return (
                    <section className="container mt-2 pl-0 pr-0">
                      <div {...getRootProps({ style })}>
                        <input {...getInputProps()} />
                        <p>
                          {" "}
                          {t(
                              "ExaminationAccess.UploadManagerDialog.FileUploadTab.DragNDropBody"
                          )}
                        </p>
                      </div>
                      <aside>
                        {this.state.files.length === 0 ? (
                            <div className="mt-3">
                              <b>
                                {" "}
                                {t(
                                    "ExaminationAccess.UploadManagerDialog.FileUploadTab.Files"
                                )}
                              </b>
                              <br />
                              <span>
                        {" "}
                                {t(
                                    "ExaminationAccess.UploadManagerDialog.FileUploadTab.NoFilesUploaded"
                                )}
                      </span>
                            </div>
                        ) : (
                            <div className="mt-3">
                              <b>
                                {" "}
                                {t(
                                    "ExaminationAccess.UploadManagerDialog.FileUploadTab.Files"
                                )}
                              </b>
                              <ul style={{ listStyle: "none", padding: "0px" }}>
                                {this.state.files.map((f, idx) => (
                                    <li key={idx}>
                                      {fileState[f.status]}
                                      <b>{f.name}:</b>{" "}
                                      {this.humanReadableFileSize(f.size)}
                                    </li>
                                ))}
                              </ul>
                            </div>
                        )}
                      </aside>
                    </section>
                );
              }}
            </Dropzone>
        ) : "" }
      </div>
    );
  }
}

export default withTranslation()(FileUploadTab);
